import React from 'react';

const ServiceItem = ({ icon, title, excerpt }) => {
  return (
    <div className="service-item column">
      <div className="service-icon-container">
        <img src={icon} alt={title} />
        <div className="bottom-border"></div>
      </div>
      <h3 className="service-item-title">{title}</h3>
      <p className="service-item-excerpt">{excerpt}</p>
    </div>
  );
};

export default ServiceItem;
